// @flow
import Href from "../../models/href/Href";

/**
 * Checks if a given url to a modular ui resource exists using a HEAD request to the resource (synchronous)
 * When the resource returns a 404, the resource does not exists and the method returns false
 *
 * @param url
 * @returns {boolean}
 */
export const resourceExists = (url: string | Href): boolean => {
  const fullUrl = new Href(url).absolutehref;

  const xhr = new XMLHttpRequest();
  xhr.open("HEAD", fullUrl, false);
  xhr.setRequestHeader("Accept", "application/json");
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");

  xhr.send();

  return xhr.status !== 404;
};

/**
 * Indicates if a request to the given url resuls in a redirect to /secureRedirect
 * @param url
 * @returns {boolean}
 */
export const resourceRedirectsToSecureLogin = (url: string | Href): boolean => {
  const fullUrl = new Href(url).absolutehref;

  const xhr = new XMLHttpRequest();
  xhr.open("HEAD", fullUrl, false);
  xhr.setRequestHeader("Accept", "application/json");
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
  xhr.send();

  const responseURL = xhr.responseURL ?? "";

  return xhr.status === 400 && responseURL.endsWith("/secureLogin");
};
